import React from 'react'
import Header from '../common/Header'
import Footer from '../common/Footer'
import CommonHeroSection from '../common/CommonHeroSection'
import CommonBreadcrumb from '../common/CommonBreadcrumb'
import AboutSection from '../sections/AboutSection'

const AboutUs = () => {
    return (
        <>
            <Header />
            <CommonHeroSection title="About Our Company" />
            <CommonBreadcrumb items={["About Us"]} />
            <AboutSection />
            <Footer />
        </>
    )
}

export default AboutUs